/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import  React ,{useEffect} from 'react';
import { Field, Form } from 'formik';
import { Button, CircularProgress, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Select, Switch } from '@mui/material';
import { TextField } from 'formik-mui';

import { useDispatch, useSelector } from 'react-redux';
import { getAllOrg } from '../../../../../../store/reducers/organization/organizationAction';
const DeviceForm = ({ values, handleBlur, handleChange, setFieldValue,  handleClose, isSubmitting, errors, touched }) => {
    const dispatch = useDispatch();
    const organizations = useSelector(state => state.organization.organizations)
    useEffect(() => {
        dispatch(getAllOrg())
    }, [dispatch]);

    return (


        <Form>

            <Grid container spacing={4}>
                {values.hasOwnProperty("deviceName") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth >
                        <Field
                            name="deviceName"
                            label="Device Name"
                            type="text"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.deviceName}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            component={TextField}
                        />
                    </FormControl>
                </Grid>}
                {values.hasOwnProperty("deviceUID") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth >
                        <Field
                            name="deviceUID"
                            label="Device UID"
                            type="text"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.deviceUID}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            component={TextField}
                        />
                    </FormControl>
                </Grid>}
                {values.hasOwnProperty("deviceOwnerID") && <Grid item xs={12} md={12} sm={12}>


                    <FormControl fullWidth error={Boolean(touched.deviceOwnerID && errors.deviceOwnerID)}>
                        <InputLabel htmlFor="outlined-status">Organization</InputLabel>
                        <Select
                            value={values.deviceOwnerID}
                            variant="outlined"
                            name="deviceOwnerID"
                            label="Owner"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {organizations?.Records?.length > 0 && organizations?.Records?.map((item) => (
                                <MenuItem value={item.organizationID}>
                                    {item.organizationName}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.organizationID}</FormHelperText>

                    </FormControl>

                </Grid>}
                {values.hasOwnProperty("detailValue") && <Grid item xs={12} md={6} sm={6}>
                    <FormControlLabel
                        control={<Switch />}
                        name="deviceDetails"
                        checked={values.detailValue === "true"}
                        onChange={(event, checked) => {
                            setFieldValue("detailValue", checked ? "true" : "false");
                        }}
                        label={values.detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                    />
                </Grid>}
                <Grid item xs={12} md={12} sm={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit" style={{ marginTop: '20px' }}
                        disabled={isSubmitting}>
                        {isSubmitting &&
                            <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                    </Button>
                    <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                </Grid>

            </Grid>
        </Form>

    )

}

 
export default DeviceForm;
